import { LocationAutocompleteInput } from '../../../../base/AutocompleteInput/LocationAutocompleteInput';
import { SvgIcon } from '../../../../base/Icon/SvgIcon';
import type { PlaceOption } from '../../../../../data/places';
import styles from './LocationInputs.module.css';

interface LocationInputsProps {
  startValue?: string;
  destinationValue?: string;
  onStartChange?: (value: string) => void;
  onDestinationChange?: (value: string) => void;
  onStartSelectOption?: (option: PlaceOption) => void;
  onDestinationSelectOption?: (option: PlaceOption) => void;
  onSwap?: () => void;
  onUseStartCurrentLocation?: () => void | Promise<void>;
  onUseDestinationCurrentLocation?: () => void | Promise<void>;
  startOptions?: PlaceOption[];
  destinationOptions?: PlaceOption[];
  disableStartCurrentLocation?: boolean;
  disableDestinationCurrentLocation?: boolean;
}

export function LocationInputs({
  startValue = '',
  destinationValue = '',
  onStartChange,
  onDestinationChange,
  onStartSelectOption,
  onDestinationSelectOption,
  onSwap,
  onUseStartCurrentLocation,
  onUseDestinationCurrentLocation,
  startOptions = [],
  destinationOptions = [],
  disableStartCurrentLocation,
  disableDestinationCurrentLocation,
}: LocationInputsProps) {
  return (
    <div className={styles.container}>
      <LocationAutocompleteInput
        placeholder="Select your start point..."
        value={startValue}
        onValueChange={onStartChange}
        options={startOptions}
        onSelectOption={onStartSelectOption}
        disableCurrentLocation={disableStartCurrentLocation}
        currentLocationAction={
          onUseStartCurrentLocation
            ? {
                onSelect: onUseStartCurrentLocation,
              }
            : undefined
        }
      />

      <button
        className={styles.swapButton}
        type="button"
        onClick={onSwap}
        aria-label="Swap"
      >
        <SvgIcon name="swap" />
      </button>

      <LocationAutocompleteInput
        placeholder="Search for a destination..."
        value={destinationValue}
        onValueChange={onDestinationChange}
        options={destinationOptions}
        onSelectOption={onDestinationSelectOption}
        disableCurrentLocation={disableDestinationCurrentLocation}
        currentLocationAction={
          onUseDestinationCurrentLocation
            ? {
                onSelect: onUseDestinationCurrentLocation,
              }
            : undefined
        }
      />
    </div>
  );
}
